import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { StaticUiText } from 'bookraw/shared/models/static-ui-text.model';
import {environment} from "env/environment";
import {Observable} from "rxjs";
import {ListResponse} from "bookraw/shared/models/api/list.response";

@Injectable()
export class StaticUiTextsService extends ListService<StaticUiText> {

  url: string = '/api/admin/texts';

  getTexts(locale: string): Observable<ListResponse<any>> {
    return this.http.get<ListResponse<any>>(environment.baseURL + '/api/admin/getTexts', {
      params: {locale}
    });
  }
}
